const MESSAGES = {
  'route_plan.invalid_recurrence': 'La recurrencia debe ser de al menos 7 días.',
  'route_plan.missing_start_date': 'Falta la fecha de inicio.',
  'route_plan.missing_visit_days': 'Seleccione al menos un día de visita.',
  'route_plan.network_error': 'No fue posible guardar el plan de visitas. Verifique su conexión e intente nuevamente.',
  'route_plan.validation_failed': 'Revise los datos del plan antes de guardar.',
  'route_plan.worker_failed': 'Ocurrió un error al procesar el plan de visitas.',
  'route_plan.worker_timeout': 'El procesamiento del plan no se completó. Intente guardar nuevamente.',
  'route_plan.processing_in_progress': 'El plan aún se está procesando. Espere unos momentos e intente de nuevo.'
}

export function mapRoutePlanError(payload) {
  if (!payload) {
    return 'Ocurrió un error inesperado. Contacte a soporte si el problema persiste.'
  }

  if (typeof payload === 'string') {
    return payload
  }

  const details = payload.details || []
  if (details.length > 0) {
    const detailMessages = details.map((detail) => {
      const baseMessage = MESSAGES[detail.code] || detail.message || MESSAGES['route_plan.validation_failed']
      if (detail.client_uid) {
        return `${baseMessage} (cliente ${detail.client_uid})`
      }
      return baseMessage
    })
    return detailMessages.join(' ')
  }

  if (payload.code && MESSAGES[payload.code]) {
    return MESSAGES[payload.code]
  }

  return payload.message || MESSAGES['route_plan.validation_failed']
}

export default MESSAGES
